import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GenericlinkComponent } from './genericlink/genericlink.component';
import { DisplayDataComponent } from './display-data/display-data.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {InstabuserComponent} from './instabuser/instabuser.component'
import { ThankYouComponent } from './thank-you/thank-you.component';
import { FailedComponent } from './failed/failed.component';
import { RpupisuccessComponent } from './RazorPayUPIResponsePage/rpupisuccess/rpupisuccess.component';
import { RpupifailureComponent } from './RazorPayUPIResponsePage/rpupifailure/rpupifailure.component';
const routes: Routes = [
  {path: "dashboard", 
  component: DashboardComponent,
  },
  {path: "Customer", 
  component: DisplayDataComponent,
  
  },
  {path: "genericLink", 
  component: GenericlinkComponent,
 
  },
  {path: "instabuser", 
  component: InstabuserComponent,
  },
  {path: "thankYou", 
  component: ThankYouComponent,
  },
  {path: "failed", 
  component: FailedComponent,
  },
  {
    path: "rpThankYou",
    component: RpupisuccessComponent,
  },
  {
    path: "rpFailed",
    component: RpupifailureComponent,
  },
  {
    path: "**",
    component: DashboardComponent,
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { 
 
}
